// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Lf5l","rightAdornment":"Header_rightAdornment__1nQNw"};